import { ContactoService } from './../../../core/services/contacto.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AlertsService } from 'src/app/core/services/alerts.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  public contactForm = null;
  constructor(
    private fb: FormBuilder,
    private svContact: ContactoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      nombre: [null, [Validators.required]],
      apellido: [null, [Validators.required]],
      telefono: [null, [Validators.required]],
      correo: [null, [Validators.required]],
      mensaje: [null, [Validators.required]],
      checkPolitics: [null, [Validators.required]],
    });
  }

  sendEmail(formValues) {
    let request = {
      apellido: formValues['apellido'],
      nombre: formValues['nombre'],
      mensaje: formValues['mensaje'],
      correo: formValues['correo'],
      telefono: formValues['telefono'],
    };
    this.svContact.sendEmail(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          Swal.fire(
            'Operación exitosa!',
            'Mensaje enviado con éxito.',
            'success'
          );
          this.router.navigate(['/home']);
        } else {
          Swal.fire('Error: Datos incorrectos', data.message, 'error');
        }
      },
      (err) => {
        Swal.fire(
          'Error: Inicio de sesión',
          'Algo salió mal al intentar iniciar sesión, intentelo más tarde',
          'error'
        );
      }
    );
  }
}
